import React, { useCallback, useEffect, useState } from "react";
import { Row, Col, Button, Spinner, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ChevronLeft, Globe, Edit } from "react-feather";
import { useNavigate, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";

import { getBrand as getBrandAction, getWholesaler as getWholesalerAction, getRetailer as getRetailerAction, rematch as rematchAction, refetch as refetchAction, resetNextTo as resetNextToAction } from "../../ReduxToolkit/Reducers/brands";
import ProfileTabsView from "../../Components/Profile/ProfileTabsView";
import ProfileInfoTab from '../../Components/Profile/ProfileInfoTab'
import ProfileScrappedDataTab from "../../Components/Profile/ProfileScrappedDataTab";
import ProfileControlsTab from "../../Components/Profile/ProfileControlsTab";
import EditEntityNameModal from "../../Components/EditEntityNameModal";
import { normalizeUrl } from "../../Utils";
import ProfileMoreInfoTab from "../../Components/Profile/ProfileMoreInfoTab";
import ProfileEngagementsTab from "../../Components/Profile/ProfileEngagementsTab";
import { convertBrandToRetailer as convertBrandToRetailerAction, convertRetailerToBrand as convertRetailerToBrandAction } from "../../ReduxToolkit/Reducers/matches";

const Profile = ({ getBrand, selectedBrand, getWholesaler, getRetailer, rematch, refetch, resetNextTo, convertRetailerToBrand, convertBrandToRetailer }) => {
  const navigate = useNavigate();
  const { id, type } = useParams();
  const [loading, setLoading] = useState(true);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [converting, setConverting] = useState(false);
  const [tab, setTab] = useState(0);
  const [editNameModal, setEditNameModal] = useState(false);

  useEffect(() => {
    if (id) _getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const _getData = async () => {
    try {
      setLoading(true);
      const action = type === 'brand' ? getBrand : type === 'retailer' ? getRetailer : getWholesaler;
      await action(id);
    } catch (err) {
      toast.error(err || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleRematch = async () => {
    setLoading(true)
    await rematch({ type, id: Number(id) });
    await _getData()
  }

  const handleRefetch = () => {
    refetch({ type, ids: [Number(id)] });
  }

  const handleResetNextTo = async () => {
    setLoading(true);
    try {
      await resetNextTo(Number(id));
      await _getData();
    } catch (err) {
      toast.error(err?.message || "Reset brands in your space failed");
    } finally {
      setLoading(false);
    }
  }

  const handleConvert = async () => {
    setConverting(true);
    console.log('selectedBrand', selectedBrand);
    try {
      let result;
      if (selectedBrand?.type === "retailer") {
        result = await convertRetailerToBrand(Number(id));
      } else {
        result = await convertBrandToRetailer(Number(id));
      }
      if (result?.statusCode === 200) {
        navigate(`/profile/${result?.data?.id}/${type === "retailer" ? "brand" : "retailer"}`);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    } finally {
      setConverting(false);
      setConfirmOpen(false);
    }
  }


  const _handleBackClick = () => {
    navigate(`/${type}s`);
  };

  return (
    <div className='page-body pt-3 h-100'>
      {loading ? (
        <Row className="justify-content-center my-5">
          <Spinner color="dark" />
        </Row>
      ) : !loading && !Object.keys(selectedBrand).length > 0 ? (
        <Row className="text-center mt-5 pt-5">
          <Col md={8} className="mx-auto">
            <h3 className="font-weight-bold">Not Found</h3>
            <p className="text-muted">
              {`Looks like ${type} is deleted or not found`}
            </p>
          </Col>
        </Row>
      ) : (
        <>
          <Row className="alignwholesaler-items-center mb-3">
            <Col xs="auto">
              <Button color="link" onClick={_handleBackClick} className="p-0 d-flex align-items-center">
                <ChevronLeft size={20} color="black" />
              </Button>
            </Col>
            <Col>
              <h4 className="font-weight-bold mb-1">{type?.toUpperCase()} PROFILE</h4>
              <div className="d-flex align-items-center">
                <span className="font-weight-semibold text-truncate" style={{ maxWidth: "250px" }}>
                  {selectedBrand?.name}
                </span>
                <button
                  className="btn p-0 ms-2"
                  onClick={() => setEditNameModal(true)}
                  style={{ border: 'none', background: 'none' }}
                >
                  <Edit size={16} color="#999" />
                </button>
                {selectedBrand?.website && (
                  <a href={normalizeUrl(selectedBrand?.website)} target="_blank" rel="noopener noreferrer" className="ms-2">
                    <Globe size={16} />
                  </a>
                )}
              </div>
            </Col>
          </Row>
          <div className="d-flex justify-content-between align-items-center">
            <ProfileTabsView tab={tab} onTabSelect={setTab} />
            <div className="d-flex align-items-center gap-2">
              {(type === 'brand' || type === 'retailer') && (
                <Button color="info" onClick={handleRefetch}>Refetch</Button>
              )}
              {type === "brand" && (
                <Button color="warning" onClick={handleResetNextTo}>Reset Brands in Your Space</Button>
              )}
              <Button color="primary" onClick={handleRematch}>Rematch</Button>
              <Button
                color={type === "retailer" ? "primary" : "success"}
                disabled={converting}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setConfirmOpen(true);
                }}
              >
                {converting ? (
                  <Spinner size="sm" style={{ width: "10px", height: "10px" }} />
                ) : type === "retailer" ? (
                  "Convert to Brand"
                ) : (
                  "Convert to Retailer"
                )}
              </Button>
            </div>
          </div>
          {tab === 0 && <ProfileInfoTab brand={selectedBrand} />}
          {tab === 1 && <ProfileScrappedDataTab selectedBrand={selectedBrand} />}
          {tab === 2 && <ProfileMoreInfoTab profile={selectedBrand} type={type} onReload={_getData} />}
          {tab === 3 && <ProfileEngagementsTab profileId={Number(id)} type={type} />}
          <EditEntityNameModal
            type={type}
            name={selectedBrand?.name}
            entityId={selectedBrand?.id}
            open={editNameModal}
            onClose={() => setEditNameModal(false)}
            onSuccess={_getData}
          />


          {/* Convert confirmation modal */}
          {confirmOpen && (
            <Modal
              isOpen={confirmOpen}
              toggle={() => !converting && setConfirmOpen(false)}
              centered
              size="md"
            >
              <ModalHeader
                toggle={() => !converting && setConfirmOpen(false)}
                style={{ borderBottom: "none", paddingBottom: 0 }}
              >
                <span style={{ fontWeight: 700 }}>Confirm Conversion</span>
              </ModalHeader>
              <ModalBody>
                <p className="mb-2">
                  You are about to convert{" "}
                  <strong>{selectedBrand?.name}</strong> from a{" "}
                  <strong>{type}</strong> to a{" "}
                  <strong>
                    {type === "retailer" ? "brand" : "retailer"}
                  </strong>
                  .
                </p>
                <p className="mb-2">This will:</p>
                <ul className="mb-3" style={{ paddingLeft: "1.2rem" }}>
                  <li>Remove this {type} from <strong>all existing matches</strong></li>
                  <li>Delete the original {type} profile</li>
                  <li>
                    Create a new{" "}
                    {type === "retailer" ? "brand" : "retailer"} profile
                  </li>
                </ul>
                <div
                  className="d-flex align-items-center gap-2 px-3 py-2 rounded"
                  style={{ backgroundColor: "#fff3cd", border: "1px solid #ffc107" }}
                >
                  <span style={{ fontSize: "16px" }}>⚠️</span>
                  <small style={{ color: "#856404", fontWeight: 500 }}>
                    This action <strong>cannot be undone</strong>.
                  </small>
                </div>
              </ModalBody>
              <ModalFooter style={{ borderTop: "none", gap: "8px" }}>
                <Button
                  color="secondary"
                  outline
                  size="sm"
                  disabled={converting}
                  onClick={() => setConfirmOpen(false)}
                >
                  Cancel
                </Button>
                <Button
                  color={type === "retailer" ? "primary" : "success"}
                  size="sm"
                  disabled={converting}
                  onClick={handleConvert}
                >
                  {converting ? (
                    <span className="d-flex align-items-center gap-1">
                      <Spinner size="sm" style={{ width: "12px", height: "12px" }} />
                      Converting…
                    </span>
                  ) : (
                    `Yes, Convert to ${type === "retailer" ? "Brand" : "Retailer"}`
                  )}
                </Button>
              </ModalFooter>
            </Modal>
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  selectedBrand: state.brands.selectedBrand,
});

const mapDispatchToProps = {
  getBrand: getBrandAction,
  rematch: rematchAction,
  refetch: refetchAction,
  resetNextTo: resetNextToAction,
  getRetailer: getRetailerAction,
  getWholesaler: getWholesalerAction,
  convertRetailerToBrand: convertRetailerToBrandAction,
  convertBrandToRetailer: convertBrandToRetailerAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
